let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ZAfE6")).then(() => parcelRequire('hOYJZ'));